import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ja from '@/i18n/ja';
import vi from '@/i18n/vi';
import en from '@/i18n/en';
import id from '@/i18n/id';
import ms from '@/i18n/ms';
import th from '@/i18n/th';
import zh from '@/i18n/zh';

const messages = { ja, vi, en, id, ms, th, zh };

/*
i18n のデフォルトのロケールの設定は
  src/pages/Root.vue
で行っている。
*/
Vue.use(VueI18n);
const i18n: VueI18n = new VueI18n({
  locale: 'ja',
  messages: { ...messages }, // ここでクローンしておかないと、例外文言の上書き時に元のオブジェクト（messages）も変更されてしまう
  missing: (locale, key) => {
    // i18nAutoGeneratedの文言で、例外のみにしか存在しない文言がある場合、通常ではIDがそのまま出力されてしまうので、空文字を返すようにしている。
    return '';
  }
});

/**
 * ロケールメッセージを初期状態にリセットする。
 */
const resetLocaleMessage = () => {
  for (const locale in messages) {
    i18n.setLocaleMessage(locale, messages[locale as keyof typeof messages]);
  }
};

// 古いブラウザではロケール一覧の取得が極端に遅い現象が見られるので、ここで一覧を取得してキャッシュしておく。
const availableLocales = i18n.availableLocales;

export default i18n;
export { availableLocales, resetLocaleMessage };
